module.exports = __webpack_public_path__ + "img/video-conference-dark.a2c00f8f.svg";